import { render, staticRenderFns } from "./36pghjyxbgb.vue?vue&type=template&id=4c355ed4&"
import script from "./36pghjyxbgb.vue?vue&type=script&lang=js&"
export * from "./36pghjyxbgb.vue?vue&type=script&lang=js&"
import style0 from "./36pghjyxbgb.vue?vue&type=style&index=0&id=4c355ed4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports